import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { 
  FiUser, FiClock, FiArrowLeft, FiArrowRight, 
   FiX
} from 'react-icons/fi';
import logo from '../../../assets/T.png';

// Import individual blog components
import WhyERPsFail from './WhyERPsFail';
import HiddenCostSpreadsheets from './HiddenCostSpreadsheets';
import TeacherWorkload from './TeacherWorkload';
import ERPvsWhatsApp from './ERPvsWhatsApp';
import AllInstitutionERP from './AllInstitutionERP';
import DifferentERPs from './DifferentERPs';
import TrustManagement from './TrustManagement';
import GroupInstitutions from './GroupInstitutions';
import OnePlatform from './OnePlatform';
import SchoolGuide from './SchoolGuide';
import PUCollegeGuide from './PUCollegeGuide';
import DegreeCollegeGuide from './DegreeCollegeGuide';
import AutonomousCollege from './AutonomousCollege';
import PrivateUniversity from './PrivateUniversity';
import CoachingCentre from './CoachingCentre';
import OnlineAdmission from './OnlineAdmission';
import AdmissionDropOff from './AdmissionDropOff';
import CollegeAdmissions from './CollegeAdmissions';
import SchoolAdmissions from './SchoolAdmissions';
import PaperlessAdmissions from './PaperlessAdmissions';
import ParentAdmissionPortal from './ParentAdmissionPortal';
import EducationAnalytics from './EducationAnalytics';
import CollegeDashboard from './CollegeDashboard';
import EarlyWarningSystem from './EarlyWarningSystem';
import InstitutionalKPIs from './InstitutionalKPIs';
import FacultyBurnout from './FacultyBurnout';
import CloudVsOnPremise from './CloudVsOnPremise';
import CloudSwitch from './CloudSwitch';
import CloudSavings from './CloudSavings';
import SecureCloudERP from './SecureCloudERP';
import ServerRoomObsolete from './ServerRoomObsolete';
import NEPCompliance from './NEPCompliance';
import CBSEReports from './CBSEReports';
import UGCAICTE from './UGCAICTE';
import BoardComparison from './BoardComparison';
import APAARID from './APAARID';
import WhatIsLMS from './WhatIsLMS';
import ERPLMS from './ERPLMS';
import CloudLMS from './BlogCloudLMS';
import LMSChallenges from './LMSChallenges';
import LMSEmpowerTeachers from './LMSEmpowerTeachers';
import BlendedLearning from './BlendedLearning';
import ERPWebsite from './ERPWebsite';
import SEOSchoolWebsite from './SEOSchoolWebsite';
import EducationalSEO from './EducationalSEO';
import AttractStudents from './AttractStudents';
import WebsiteVSERP from './WebsiteVSERP';
import MobileFirst from './MobileFirst';
import UXBurnout from './UXBurnout';
import CommunityEngagement from './CommunityEngagement';



// Blog metadata
export const blogContent = {
  'why-erps-fail': {
    title: 'Why Most School ERPs Fail in India: 6 Ground Reality Mismatches',
    description: 'Discover why 70% of school ERPs fail in India. Learn the 6 critical ground reality mismatches.',
    date: 'August 13, 2025',
    readTime: '8 min read',
    author: 'Truyon Team',
    category: 'ERP Implementation',
    seoTitle: 'Why Most School ERPs Fail in India | Truyon',
    seoDescription: 'Discover why 70% of school ERPs fail in India.',
    component: WhyERPsFail
  },
  'hidden-cost-of-spreadsheets': {
    title: 'The Hidden Cost of Using Spreadsheets in Indian Education',
    description: 'Discover the hidden costs of using spreadsheets for school administration.',
    date: 'August 13, 2025',
    readTime: '10 min read',
    author: 'Truyon Team',
    category: 'Core Problems',
    seoTitle: 'Hidden Cost of Spreadsheets in Indian Education | Truyon',
    seoDescription: 'Discover the hidden costs of using spreadsheets for school administration.',
    component: HiddenCostSpreadsheets
  },
  'teacher-workload-solution': {
    title: 'Teachers & Professors Spend 8 Hours Weekly on Admin Work: Here\'s How to Fix It',
    description: 'Discover why teachers spend 8+ hours weekly on administrative tasks and how to give educators their time back with smart automation.',
    date: 'August 14, 2025',
    readTime: '7 min read',
    author: 'Truyon Team',
    category: 'Core Problems',
    seoTitle: 'Teachers Spend 8 Hours Weekly on Admin Work | Truyon',
    seoDescription: 'Discover why teachers spend 8+ hours weekly on administrative tasks.',
    component: TeacherWorkload
  },
  'ERP-vs-whatsapp': {
  title: 'ERP vs. WhatsApp: Why Educational Institutions Need More Than Just a Chat Group',
  description: 'Why WhatsApp is failing schools and how a structured ERP communication system solves the chaos, burnout, and security risks.',
  date: 'August 15, 2025',
  readTime: '8 min read',
  author: 'Truyon Team',
  category: 'Core Problems',
  seoTitle: 'ERP vs WhatsApp: Why Schools Need More Than Just a Chat Group | Truyon',
  seoDescription: 'Why WhatsApp is failing schools - teacher burnout, lost messages, security risks. Learn how Truyon provides a better communication solution.',
  component: ERPvsWhatsApp
},
'unified-erp-for-all-institutions': {
  title: 'Why Can\'t My ERP Handle All My Institutions? – The Unified Platform Solution',
  description: 'Why educational trusts struggle with multi-institution management and how a unified ERP platform solves the chaos of disconnected systems.',
  date: 'August 15, 2025',
  readTime: '9 min read',
  author: 'Truyon Team',
  category: 'Multi-Institution',
  seoTitle: 'Unified ERP for All Institutions: Why Your ERP Can\'t Handle Multiple Schools | Truyon',
  seoDescription: 'Why educational trusts struggle with multi-institution management. Learn how a unified ERP platform solves the chaos of disconnected systems.',
  component: AllInstitutionERP
},
'school-vs-college-vs-university-erp': {
  title: 'School vs. PU College vs. Degree College vs. University: Do You Really Need Different ERPs?',
  description: 'Why schools, PU colleges, degree colleges, and universities need different ERP features—and how one unified platform can handle them all.',
  date: 'August 16, 2025',
  readTime: '9 min read',
  author: 'Truyon Team',
  category: 'Multi-Institution',
  seoTitle: 'School vs College vs University ERP: Do You Need Different ERPs? | Truyon',
  seoDescription: 'Why schools, PU colleges, degree colleges, and universities need different ERP features—and how one unified platform can handle them all.',
  component: DifferentERPs
},
'educational-trust-management': {
  title: 'How a Unified ERP Helps Educational Trusts Manage Multiple Institutions Seamlessly',
  description: 'How educational trusts can manage multiple schools, colleges, and universities from one platform—with complete visibility, consistent standards, and efficient operations.',
  date: 'August 17, 2025',
  readTime: '8 min read',
  author: 'Truyon Team',
  category: 'Multi-Institution',
  seoTitle: 'How a Unified ERP Helps Educational Trusts Manage Multiple Institutions Seamlessly | Truyon',
  seoDescription: 'How educational trusts can manage multiple schools, colleges, and universities from one platform—with complete visibility, consistent standards, and efficient operations.',
  component: TrustManagement
},
'managing-group-of-institutions': {
  title: 'The Challenges of Managing a Group of Institutions (And How to Solve Them)',
  description: 'The real challenges of managing multiple educational institutions—inconsistent processes, data silos, manual consolidation—and how a unified ERP solves them all.',
  date: 'August 18, 2025',
  readTime: '9 min read',
  author: 'Truyon Team',
  category: 'Multi-Institution',
  seoTitle: 'Managing a Group of Institutions: Challenges and Solutions | Truyon',
  seoDescription: 'The real challenges of managing multiple educational institutions—inconsistent processes, data silos, manual consolidation—and how a unified ERP solves them all.',
  component: GroupInstitutions
},
'one-platform-every-institution': {
  title: 'One Platform Every Institution: Why India Needs a Versatile Educational ERP',
  description: 'Why India needs a versatile educational ERP that can handle schools, PU colleges, degree colleges, and universities—all on one unified platform.',
  date: 'August 18, 2025',
  readTime: '8 min read',
  author: 'Truyon Team',
  category: 'Multi-Institution',
  seoTitle: 'Why India Needs a Versatile Educational ERP for All Institutions | Truyon',
  seoDescription: 'Why India needs a versatile educational ERP that can handle schools, PU colleges, degree colleges, and universities—all on one unified platform.',
  component: OnePlatform
},
'school-management-guide': {
  title: 'The Complete Guide to School Management Software for K-12 Schools in India',
  description: 'Everything you need to know about choosing school management software for K-12 schools in India—essential features, common mistakes, and how to make the right decision.',
  date: 'August 19, 2025',
  readTime: '10 min read',
  author: 'Truyon Team',
  category: 'Institution-Specific',
  seoTitle: 'Complete Guide to School Management Software for K-12 Schools in India | Truyon',
  seoDescription: 'Everything you need to know about choosing school management software for K-12 schools in India—essential features, common mistakes, and how to make the right decision.',
  component: SchoolGuide
},
'pu-college-management': {
  title: 'PU College Management System: Why Pre-University Colleges Need Specialized ERPs',
  description: 'Why PU colleges need specialized ERPs to manage stream choices, subject combinations, board exam requirements, and competitive exam preparation.',
  date: 'August 20, 2025',
  readTime: '9 min read',
  author: 'Truyon Team',
  category: 'Institution-Specific',
  seoTitle: 'PU College Management System: Why Pre-University Colleges Need Specialized ERPs | Truyon',
  seoDescription: 'Why PU colleges need specialized ERPs to manage stream choices, subject combinations, board exam requirements, and competitive exam preparation.',
  component: PUCollegeGuide
},
'degree-college-erp': {
  title: 'Degree College ERP: Managing Undergraduate & Postgraduate Programs Efficiently',
  description: 'Why degree colleges need specialized ERPs to manage UG programs, PG programs, credit systems, semester transitions, and accreditation requirements.',
  date: 'August 21, 2025',
  readTime: '9 min read',
  author: 'Truyon Team',
  category: 'Institution-Specific',
  seoTitle: 'Degree College ERP: Managing UG & PG Programs Efficiently | Truyon',
  seoDescription: 'Why degree colleges need specialized ERPs to manage UG programs, PG programs, credit systems, semester transitions, and accreditation requirements.',
  component: DegreeCollegeGuide
},
'autonomous-college-management': {
  title: 'Autonomous Colleges in India: Why You Need a Flexible ERP for Self-Governance',
  description: 'Why autonomous colleges need flexible ERPs to design custom curricula, implement innovative evaluation methods, and maintain accreditation standards.',
  date: 'August 22, 2025',
  readTime: '9 min read',
  author: 'Truyon Team',
  category: 'Institution-Specific',
  seoTitle: 'Autonomous Colleges in India: Why You Need a Flexible ERP for Self-Governance | Truyon',
  seoDescription: 'Why autonomous colleges need flexible ERPs to design custom curricula, implement innovative evaluation methods, and maintain accreditation standards.',
  component: AutonomousCollege
},
'private-university-management': {
  title: 'University Management System: How Private Universities Are Digitizing Operations',
  description: 'How private universities are digitizing operations with integrated ERP systems—managing multiple colleges, diverse programs, faculty, research, and accreditation.',
  date: 'August 23, 2025',
  readTime: '9 min read',
  author: 'Truyon Team',
  category: 'Institution-Specific',
  seoTitle: 'University Management System: How Private Universities Are Digitizing Operations | Truyon',
  seoDescription: 'How private universities are digitizing operations with integrated ERP systems—managing multiple colleges, diverse programs, faculty, research, and accreditation.',
  component: PrivateUniversity
},
'coaching-centre-management': {
  title: 'Coaching Centre Management Software: Scaling Your Institute with the Right ERP',
  description: 'How coaching centre management software helps you scale your institute—batch management, mock test analytics, parent communication, and fee tracking in one platform.',
  date: 'August 24, 2025',
  readTime: '9 min read',
  author: 'Truyon Team',
  category: 'Institution-Specific',
  seoTitle: 'Coaching Centre Management Software: Scale Your Institute with the Right ERP | Truyon',
  seoDescription: 'How coaching centre management software helps you scale your institute—batch management, mock test analytics, parent communication, and fee tracking in one platform.',
  component: CoachingCentre
},
'online-admission-management': {
  title: 'Online Admission Management: How Indian Institutions Are Filling Seats Faster',
  description: 'How online admission management is transforming Indian education—24/7 applications, automated verification, real-time tracking, and integrated payments.',
  date: 'August 25, 2025',
  readTime: '9 min read',
  author: 'Truyon Team',
  category: 'Admissions',
  seoTitle: 'Online Admission Management: How Indian Institutions Are Filling Seats Faster | Truyon',
  seoDescription: 'How online admission management is transforming Indian education—24/7 applications, automated verification, real-time tracking, and integrated payments.',
  component: OnlineAdmission
},
'reduce-admission-drop-off': {
  title: 'How to Reduce Admission Drop-Offs with a Digital Application Process',
  description: 'Why applicants abandon the admission process and how a digital application system reduces drop-offs, fills seats faster, and improves the applicant experience.',
  date: 'August 26, 2025',
  readTime: '9 min read',
  author: 'Truyon Team',
  category: 'Admissions',
  seoTitle: 'How to Reduce Admission Drop-Offs with a Digital Application Process | Truyon',
  seoDescription: 'Why applicants abandon the admission process and how a digital application system reduces drop-offs, fills seats faster, and improves the applicant experience.',
  component: AdmissionDropOff
},
'college-admissions-guide': {
  title: 'The Ultimate Guide to College Admissions in India: Going Digital in 2026',
  description: 'The complete guide to digital college admissions in India—trends, process steps, benefits, and how to modernize your admission experience in 2026.',
  date: 'August 27, 2025',
  readTime: '10 min read',
  author: 'Truyon Team',
  category: 'Admissions',
  seoTitle: 'The Ultimate Guide to College Admissions in India: Going Digital in 2026 | Truyon',
  seoDescription: 'The complete guide to digital college admissions in India—trends, process steps, benefits, and how to modernize your admission experience in 2026.',
  component: CollegeAdmissions
},
'school-admissions-guide': {
  title: 'School Admissions in India: How Private Schools Are Enrolling Students Faster',
  description: 'How private schools in India are using digital admission processes to enroll students faster—online applications, parent-friendly forms, automated communication, and efficient management.',
  date: 'August 28, 2025',
  readTime: '9 min read',
  author: 'Truyon Team',
  category: 'Admissions',
  seoTitle: 'School Admissions in India: How Private Schools Are Enrolling Students Faster | Truyon',
  seoDescription: 'How private schools in India are using digital admission processes to enroll students faster—online applications, parent-friendly forms, automated communication, and efficient management.',
  component: SchoolAdmissions
},
'paperless-admissions': {
  title: 'Paperless Admissions: How to Enroll 500+ Students in 10 Days',
  description: 'How institutions are using paperless admission processes to enroll 500+ students in just 10 days—online applications, digital document management, automated communication, and fast decision-making.',
  date: 'August 29, 2025',
  readTime: '9 min read',
  author: 'Truyon Team',
  category: 'Admissions',
  seoTitle: 'Paperless Admissions: How to Enroll 500+ Students in 10 Days | Truyon',
  seoDescription: 'How institutions are using paperless admission processes to enroll 500+ students in just 10 days—online applications, digital document management, automated communication, and fast decision-making.',
  component: PaperlessAdmissions
},'online-admission-portal': {
  title: 'Why Parents & Students Prefer Institutions with Online Admission Portals',
  description: 'Why parents and students prefer institutions with online admission portals—convenience, real-time updates, mobile-friendly experience, and positive first impressions.',
  date: 'August 30, 2025',
  readTime: '9 min read',
  author: 'Truyon Team',
  category: 'Admissions',
  seoTitle: 'Why Parents & Students Prefer Institutions with Online Admission Portals | Truyon',
  seoDescription: 'Why parents and students prefer institutions with online admission portals—convenience, real-time updates, mobile-friendly experience, and positive first impressions.',
  component: ParentAdmissionPortal
},
'educational-analytics': {
  title: 'From Gut Feeling to Data: How Educational Analytics Drives Growth in India',
  description: 'How Indian educational institutions are using data analytics to drive growth, improve student outcomes, optimize resource allocation, and build stronger institutions.',
  date: 'August 31, 2025',
  readTime: '9 min read',
  author: 'Truyon Team',
  category: 'Analytics',
  seoTitle: 'From Gut Feeling to Data: How Educational Analytics Drives Growth in India | Truyon',
  seoDescription: 'How Indian educational institutions are using data analytics to drive growth, improve student outcomes, optimize resource allocation, and build stronger institutions.',
  component: EducationAnalytics
},
'college-principal-dashboard': {
  title: 'How a College Analytics Dashboard Helps Deans & Principals Make Smarter Decisions',
  description: 'How deans and principals use college analytics dashboards to make smarter decisions—enrollment tracking, academic performance, faculty workload, financial metrics, and accreditation readiness.',
  date: 'September 1, 2025',
  readTime: '9 min read',
  author: 'Truyon Team',
  category: 'Analytics',
  seoTitle: 'How a College Analytics Dashboard Helps Deans & Principals Make Smarter Decisions | Truyon',
  seoDescription: 'How deans and principals use college analytics dashboards to make smarter decisions—enrollment tracking, academic performance, faculty workload, financial metrics, and accreditation readiness.',
  component: CollegeDashboard
},
'early-warning-system': {
  title: 'Predicting Student Performance: How Early Warning Systems Work in Higher Education',
  description: 'How early warning systems in higher education predict student performance, identify at-risk students, and enable timely intervention to prevent dropout and academic failure.',
  date: 'September 2, 2025',
  readTime: '9 min read',
  author: 'Truyon Team',
  category: 'Analytics',
  seoTitle: 'Predicting Student Performance: How Early Warning Systems Work in Higher Education | Truyon',
  seoDescription: 'How early warning systems in higher education predict student performance, identify at-risk students, and enable timely intervention to prevent dropout and academic failure.',
  component: EarlyWarningSystem
},
'institutional-kpis': {
  title: '5 KPIs Every Educational Leader Should Track in Real-Time',
  description: '5 key performance indicators every educational leader should track in real-time—enrollment, retention, academic performance, admission conversion, and faculty workload. Drive better decisions with data.',
  date: 'September 3, 2025',
  readTime: '9 min read',
  author: 'Truyon Team',
  category: 'Analytics',
  seoTitle: '5 KPIs Every Educational Leader Should Track in Real-Time | Truyon',
  seoDescription: '5 key performance indicators every educational leader should track in real-time—enrollment, retention, academic performance, admission conversion, and faculty workload. Drive better decisions with data.',
  component: InstitutionalKPIs
},
'faculty-burnout-prevention': {
  title: 'How Data Helps You Spot Faculty Burnout Before It Happens',
  description: 'How data analytics helps educational institutions spot faculty burnout early—workload tracking, engagement monitoring, feedback trends, and retention insights.',
  date: 'September 4, 2025',
  readTime: '9 min read',
  author: 'Truyon Team',
  category: 'Analytics',
  seoTitle: 'How Data Helps You Spot Faculty Burnout Before It Happens | Truyon',
  seoDescription: 'How data analytics helps educational institutions spot faculty burnout early—workload tracking, engagement monitoring, feedback trends, and retention insights.',
  component: FacultyBurnout
},
'cloud-vs-on-premise-erp': {
  title: 'Cloud-Based vs. On-Premise Educational ERP: A Complete Guide for India',
  description: 'A complete guide to choosing between cloud-based and on-premise educational ERP for Indian institutions—cost, accessibility, security, scalability, and the Indian context.',
  date: 'September 5, 2025',
  readTime: '9 min read',
  author: 'Truyon Team',
  category: 'Cloud',
  seoTitle: 'Cloud-Based vs. On-Premise Educational ERP: A Complete Guide for India | Truyon',
  seoDescription: 'A complete guide to choosing between cloud-based and on-premise educational ERP for Indian institutions—cost, accessibility, security, scalability, and the Indian context.',
  component: CloudVsOnPremise
},
'switch-to-cloud-erp': {
  title: 'Why Indian Educational Leaders Are Switching to Cloud-Based ERP in 2025',
  description: 'Why Indian educational leaders are switching to cloud-based ERP in 2025—digital infrastructure, mobile-first generation, cost savings, hybrid learning, and the future of education.',
  date: 'September 6, 2025',
  readTime: '9 min read',
  author: 'Truyon Team',
  category: 'Cloud',
  seoTitle: 'Why Indian Educational Leaders Are Switching to Cloud-Based ERP in 2025 | Truyon',
  seoDescription: 'Why Indian educational leaders are switching to cloud-based ERP in 2025—digital infrastructure, mobile-first generation, cost savings, hybrid learning, and the future of education.',
  component: CloudSwitch
},
'cloud-erp-cost-savings': {
  title: 'How Cloud ERP Saves Indian Institutions ₹5-10 Lakhs Annually on IT Maintenance',
  description: 'How cloud ERP saves Indian educational institutions ₹5-10 lakhs annually on IT maintenance—hardware costs, IT staff, license fees, backup, energy, and training.',
  date: 'September 7, 2025',
  readTime: '9 min read',
  author: 'Truyon Team',
  category: 'Cloud',
  seoTitle: 'How Cloud ERP Saves Indian Institutions ₹5-10 Lakhs Annually on IT Maintenance | Truyon',
  seoDescription: 'How cloud ERP saves Indian educational institutions ₹5-10 lakhs annually on IT maintenance—hardware costs, IT staff, license fees, backup, energy, and training.',
  component: CloudSavings
},
'secure-cloud-erp': {
  title: 'Can an Educational ERP Be Both Secure and Accessible from Anywhere? (Yes.)',
  description: 'Yes, an educational ERP can be both secure and accessible from anywhere—with end-to-end encryption, multi-factor authentication, role-based access, and 24/7 security monitoring.',
  date: 'September 8, 2025',
  readTime: '9 min read',
  author: 'Truyon Team',
  category: 'Cloud',
  seoTitle: 'Can an Educational ERP Be Both Secure and Accessible from Anywhere? | Truyon',
  seoDescription: 'Yes, an educational ERP can be both secure and accessible from anywhere—with end-to-end encryption, multi-factor authentication, role-based access, and 24/7 security monitoring.',
  component: SecureCloudERP
},
'server-room-obsolete': {
  title: 'Why Your Institution\'s Server Room is Obsolete (And What to Do About It)',
  description: 'Why server rooms are obsolete in 2026—high costs, IT staff burnout, security risks, scaling nightmares—and how cloud ERP eliminates all these problems.',
  date: 'September 9, 2025',
  readTime: '9 min read',
  author: 'Truyon Team',
  category: 'Cloud',
  seoTitle: 'Why Your Institution\'s Server Room is Obsolete (And What to Do About It) | Truyon',
  seoDescription: 'Why server rooms are obsolete in 2026—high costs, IT staff burnout, security risks, scaling nightmares—and how cloud ERP eliminates all these problems.',
  component: ServerRoomObsolete
},
'nep-2020-compliance': {
  title: 'NEP 2020 Compliance: How Educational ERP Helps You Meet New Standards',
  description: 'How educational ERP helps institutions meet NEP 2020 compliance standards—flexible curriculum, Academic Bank of Credits, competency-based assessment, and automated compliance reporting.',
  date: 'September 10, 2025',
  readTime: '9 min read',
  author: 'Truyon Team',
  category: 'Compliance',
  seoTitle: 'NEP 2020 Compliance: How Educational ERP Helps You Meet New Standards | Truyon',
  seoDescription: 'How educational ERP helps institutions meet NEP 2020 compliance standards—flexible curriculum, Academic Bank of Credits, competency-based assessment, and automated compliance reporting.',
  component: NEPCompliance
},
'cbse-report-generator': {
  title: 'CBSE Compliance Report Generation: Save 40+ Hours a Month for Schools',
  description: 'How automated CBSE report generation saves schools 40+ hours monthly—attendance, academic performance, enrollment, examination, and faculty records.',
  date: 'September 11, 2025',
  readTime: '9 min read',
  author: 'Truyon Team',
  category: 'Compliance',
  seoTitle: 'CBSE Compliance Report Generation: Save 40+ Hours a Month for Schools | Truyon',
  seoDescription: 'How automated CBSE report generation saves schools 40+ hours monthly—attendance, academic performance, enrollment, examination, and faculty records.',
  component: CBSEReports
},
'ugc-aicte-compliance': {
  title: 'UGC & AICTE Compliance: How Degree Colleges & Universities Stay Audit-Ready',
  description: 'How degree colleges and universities stay audit-ready with UGC and AICTE compliance—program records, faculty documentation, student records, and automated compliance reporting.',
  date: 'September 12, 2025',
  readTime: '9 min read',
  author: 'Truyon Team',
  category: 'Compliance',
  seoTitle: 'UGC & AICTE Compliance: How Degree Colleges & Universities Stay Audit-Ready | Truyon',
  seoDescription: 'How degree colleges and universities stay audit-ready with UGC and AICTE compliance—program records, faculty documentation, student records, and automated compliance reporting.',
  component: UGCAICTE
},
'board-university-erp-comparison': {
  title: 'ICSE vs. CBSE vs. State Board vs. University: Which ERP Features Matter Most?',
  description: 'Comparing ERP features for CBSE, ICSE, State Board, and Universities—attendance tracking, academic reporting, exam management, compliance, and more.',
  date: 'September 12, 2025',
  readTime: '9 min read',
  author: 'Truyon Team',
  category: 'Compliance',
  seoTitle: 'ICSE vs. CBSE vs. State Board vs. University: Which ERP Features Matter Most? | Truyon',
  seoDescription: 'Comparing ERP features for CBSE, ICSE, State Board, and Universities—attendance tracking, academic reporting, exam management, compliance, and more.',
  component: BoardComparison
},
'apaar-id-management': {
  title: 'What is APAAR ID & How Can Your Institution Manage It Digitally?',
  description: 'What is APAAR ID, how it works, and how institutions can manage it digitally—consent forms, data verification, NAD integration, and DigiLocker integration.',
  date: 'September 12, 2025',
  readTime: '9 min read',
  author: 'Truyon Team',
  category: 'Compliance',
  seoTitle: 'What is APAAR ID & How Can Your Institution Manage It Digitally? | Truyon',
  seoDescription: 'What is APAAR ID, how it works, and how institutions can manage it digitally—consent forms, data verification, NAD integration, and DigiLocker integration.',
  component: APAARID
},
'what-is-lms': {
  title: 'What Is a Learning Management System (LMS) and Do Indian Institutions Need One?',
  description: 'What is a Learning Management System (LMS), key features, benefits for Indian institutions, and why integrated LMS with ERP is the future of education.',
  date: 'September 12, 2025',
  readTime: '9 min read',
  author: 'Truyon Team',
  category: 'LMS',
  seoTitle: 'What Is a Learning Management System (LMS) and Do Indian Institutions Need One? | Truyon',
  seoDescription: 'What is a Learning Management System (LMS), key features, benefits for Indian institutions, and why integrated LMS with ERP is the future of education.',
  component: WhatIsLMS
},
'erp-lms-integration': {
  title: 'ERP + LMS: The Holy Grail of Education Technology Explained',
  description: 'Why integrating ERP and LMS is the holy grail of education technology—seamless student data flow, unified profiles, real-time analytics, and reduced administrative burden.',
  date: 'September 12, 2025',
  readTime: '9 min read',
  author: 'Truyon Team',
  category: 'LMS',
  seoTitle: 'ERP + LMS: The Holy Grail of Education Technology Explained | Truyon',
  seoDescription: 'Why integrating ERP and LMS is the holy grail of education technology—seamless student data flow, unified profiles, real-time analytics, and reduced administrative burden.',
  component: ERPLMS
},
'cloud-lms-vs-traditional': {
  title: 'Cloud LMS vs. Traditional LMS: Key Differences for Indian Education',
  description: 'Key differences between cloud LMS and traditional LMS—accessibility, cost, scalability, security, and why cloud is the future for Indian education.',
  date: 'September 12, 2025',
  readTime: '9 min read',
  author: 'Truyon Team',
  category: 'LMS',
  seoTitle: 'Cloud LMS vs. Traditional LMS: Key Differences for Indian Education | Truyon',
  seoDescription: 'Key differences between cloud LMS and traditional LMS—accessibility, cost, scalability, security, and why cloud is the future for Indian education.',
  component: CloudLMS
},
'lms-implementation-challenges': {
  title: 'Challenges in Implementing LMS for Schools Colleges & Coaching Centres',
  description: 'Top challenges in implementing LMS for schools, colleges, and coaching centres—teacher resistance, connectivity, infrastructure, training, integration, and security—and how to overcome them.',
  date: 'September 12, 2025',
  readTime: '10 min read',
  author: 'Truyon Team',
  category: 'LMS',
  seoTitle: 'Challenges in Implementing LMS for Schools Colleges & Coaching Centres | Truyon',
  seoDescription: 'Top challenges in implementing LMS for schools, colleges, and coaching centres—teacher resistance, connectivity, infrastructure, training, integration, and security—and how to overcome them.',
  component: LMSChallenges
},
'lms-empower-teachers': {
  title: 'How to Use an LMS to Actually Empower Teachers & Professors (Not Exhaust Them)',
  description: 'How to use an LMS to actually empower teachers—automating admin work, reusable content, real-time student insights, and streamlined communication.',
  date: 'September 12, 2025',
  readTime: '9 min read',
  author: 'Truyon Team',
  category: 'LMS',
  seoTitle: 'How to Use an LMS to Actually Empower Teachers & Professors (Not Exhaust Them) | Truyon',
  seoDescription: 'How to use an LMS to actually empower teachers—automating admin work, reusable content, real-time student insights, and streamlined communication.',
  component: LMSEmpowerTeachers
},
'blended-learning-lms': {
  title: 'Blended Learning in India: How an LMS Makes Hybrid Classrooms & Campuses Work',
  description: 'How an LMS powers blended learning in India—recorded lectures, live virtual classes, self-paced learning, collaboration, and real-time progress tracking.',
  date: 'September 12, 2025',
  readTime: '9 min read',
  author: 'Truyon Team',
  category: 'LMS',
  seoTitle: 'Blended Learning in India: How an LMS Makes Hybrid Classrooms & Campuses Work | Truyon',
  seoDescription: 'How an LMS powers blended learning in India—recorded lectures, live virtual classes, self-paced learning, collaboration, and real-time progress tracking.',
  component: BlendedLearning
},
'erp-with-website-builder': {
  title: 'Can an Educational ERP Also Be a Powerful Public Website? Yes Here\'s How',
  description: 'How an educational ERP can also power your public website—unified brand experience, no separate CMS, parent portals, easy content updates, and SEO readiness.',
  date: 'September 12, 2025',
  readTime: '9 min read',
  author: 'Truyon Team',
  category: 'Website-SEO',
  seoTitle: 'Can an Educational ERP Also Be a Powerful Public Website? Yes Here\'s How | Truyon',
  seoDescription: 'How an educational ERP can also power your public website—unified brand experience, no separate CMS, parent portals, easy content updates, and SEO readiness.',
  component: ERPWebsite
},
'seo-for-institution-website': {
  title: 'Why Your Institution Needs an SEO-Optimized Website (Not Just a Facebook Page)',
  description: 'Why educational institutions need an SEO-optimized website—not just a Facebook page—to get found on Google, build trust, and attract more students.',
  date: 'September 12, 2025',
  readTime: '9 min read',
  author: 'Truyon Team',
  category: 'Website-SEO',
  seoTitle: 'Why Your Institution Needs an SEO-Optimized Website (Not Just a Facebook Page) | Truyon',
  seoDescription: 'Why educational institutions need an SEO-optimized website—not just a Facebook page—to get found on Google, build trust, and attract more students.',
  component: SEOSchoolWebsite
},
'educational-seo-guide': {
  title: 'How to Get Your School College or Coaching Centre Found on Google',
  description: 'Step-by-step guide to getting your school, college, or coaching centre found on Google—keyword research, local SEO, program pages, content marketing, and mobile optimization.',
  date: 'September 12, 2025',
  readTime: '10 min read',
  author: 'Truyon Team',
  category: 'Website-SEO',
  seoTitle: 'How to Get Your School College or Coaching Centre Found on Google | Truyon',
  seoDescription: 'Step-by-step guide to getting your school, college, or coaching centre found on Google—keyword research, local SEO, program pages, content marketing, and mobile optimization.',
  component: EducationalSEO
},
'attract-students-with-seo': {
  title: 'The Secret to Attracting More Students: A Website That Actually Ranks',
  description: 'The secret to attracting more students is having a website that actually ranks on Google—speak parent language, show up where parents search, and build credibility through your website.',
  date: 'September 12, 2025',
  readTime: '9 min read',
  author: 'Truyon Team',
  category: 'Website-SEO',
  seoTitle: 'The Secret to Attracting More Students: A Website That Actually Ranks | Truyon',
  seoDescription: 'The secret to attracting more students is having a website that actually ranks on Google—speak parent language, show up where parents search, and build credibility through your website.',
  component: AttractStudents
},
'website-vs-erp': {
  title: 'Institution Website vs. ERP: Why They Should Be One and the Same',
  description: 'Why your institution\'s website and ERP should be one integrated platform—single login, consistent design, real-time data, reduced complexity, and better SEO.',
  date: 'September 12, 2025',
  readTime: '9 min read',
  author: 'Truyon Team',
  category: 'Website-SEO',
  seoTitle: 'Institution Website vs. ERP: Why They Should Be One and the Same | Truyon',
  seoDescription: 'Why your institution\'s website and ERP should be one integrated platform—single login, consistent design, real-time data, reduced complexity, and better SEO.',
  component: WebsiteVSERP
},
'mobile-first-education-erp': {
  title: 'Why Mobile-First Design Matters for Indian Educational Management Software',
  description: 'Why mobile-first design is essential for educational management software in India—teachers and staff use mobile primarily, parents expect mobile access, and India is a mobile-first internet market.',
  date: 'September 12, 2025',
  readTime: '9 min read',
  author: 'Truyon Team',
  category: 'Mobile-UX',
  seoTitle: 'Why Mobile-First Design Matters for Indian Educational Management Software | Truyon',
  seoDescription: 'Why mobile-first design is essential for educational management software in India—teachers and staff use mobile primarily, parents expect mobile access, and India is a mobile-first internet market.',
  component: MobileFirst
},
'ux-educator-burnout': {
  title: 'How Great User Experience (UX) Reduces Educator & Staff Burnout',
  description: 'How great user experience in educational software reduces educator and staff burnout—intuitive interfaces, faster task completion, reduced cognitive load, and less frustration.',
  date: 'September 12, 2025',
  readTime: '9 min read',
  author: 'Truyon Team',
  category: 'Mobile-UX',
  seoTitle: 'How Great User Experience (UX) Reduces Educator & Staff Burnout | Truyon',
  seoDescription: 'How great user experience in educational software reduces educator and staff burnout—intuitive interfaces, faster task completion, reduced cognitive load, and less frustration.',
  component: UXBurnout
},
// Add to blogContent object
'education-community-engagement': {
  title: 'Parent Student & Faculty Engagement: How a Modern ERP Builds Stronger Communities',
  description: 'How a modern educational ERP builds stronger communities through parent engagement, student ownership, faculty collaboration, and real-time communication between all stakeholders.',
  date: 'September 12, 2025',
  readTime: '9 min read',
  author: 'Truyon Team',
  category: 'Mobile-UX',
  seoTitle: 'Parent Student & Faculty Engagement: How a Modern ERP Builds Stronger Communities | Truyon',
  seoDescription: 'How a modern educational ERP builds stronger communities through parent engagement, student ownership, faculty collaboration, and real-time communication between all stakeholders.',
  component: CommunityEngagement
},

};

const BlogPost = () => {
  const navigate = useNavigate();
  const { slug } = useParams();
  const [isDemoModalOpen, setIsDemoModalOpen] = useState(false);
  const post = blogContent[slug];

  // SEO
  useEffect(() => {
    if (post) {
      document.title = post.seoTitle;
      const metaDescription = document.querySelector('meta[name="description"]');
      if (metaDescription) {
        metaDescription.content = post.seoDescription;
      }
    }
  }, [post]);

  // Blog listing page (when no slug)
  if (!slug) {
    const posts = Object.entries(blogContent).map(([slug, post]) => ({ slug, ...post }));
    return (
      <div className="min-h-screen bg-slate-50">
        <header className="bg-white border-b border-slate-200 sticky top-0 z-30">
          <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
            <Link to="/" className="flex items-center gap-2.5">
              <img src={logo} alt="Truyon Logo" className="w-8 h-8 object-contain" />
              <span className="text-xl font-bold tracking-tight text-slate-900">truyon</span>
            </Link>
            <button onClick={() => navigate('/')} className="px-4 py-2 bg-indigo-600 text-white text-sm font-semibold rounded-lg hover:bg-indigo-700">
              Back to Home
            </button>
          </div>
        </header>
        <main className="w-full max-w-6xl mx-auto px-4 sm:px-6 py-10">
          <div className="mb-8">
            <span className="inline-flex items-center rounded-full bg-indigo-50 px-3 py-1 text-sm font-semibold text-indigo-700">Blog</span>
            <h1 className="mt-4 text-3xl sm:text-4xl font-extrabold text-slate-900">All Articles</h1>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
            {posts.map((article) => (
              <button
                key={article.slug}
                onClick={() => navigate(`/blog/${article.slug}`)}
                className="group text-left bg-white border border-slate-200 rounded-2xl p-6 shadow-sm hover:shadow-lg transition-all hover:-translate-y-1"
              >
                <div className="mb-3 inline-flex rounded-full bg-indigo-50 px-2.5 py-1 text-xs font-semibold text-indigo-700">
                  {article.category}
                </div>
                <h2 className="text-lg font-bold text-slate-900 group-hover:text-indigo-600 transition-colors">
                  {article.title}
                </h2>
                <div className="mt-4 flex items-center justify-between text-xs text-slate-500">
                  <span>{article.date}</span>
                  <span>{article.readTime}</span>
                </div>
              </button>
            ))}
          </div>
        </main>
      </div>
    );
  }

  // 404 - Post not found
  if (!post) {
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4">
        <div className="max-w-lg w-full bg-white border border-slate-200 rounded-2xl p-8 text-center">
          <h1 className="text-2xl font-bold text-slate-900">Article not found</h1>
          <Link to="/blog" className="mt-6 inline-flex px-5 py-3 bg-indigo-600 text-white rounded-xl font-semibold hover:bg-indigo-700">
            View all articles
          </Link>
        </div>
      </div>
    );
  }

  // Render the component
  const ContentComponent = post.component;

  return (
    <div className="min-h-screen bg-slate-50">
      <header className="bg-white border-b border-slate-200 sticky top-0 z-30">
        <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5">
            <img src={logo} alt="Truyon Logo" className="w-8 h-8 object-contain" />
            <span className="text-xl font-bold tracking-tight text-slate-900">truyon</span>
          </Link>
          <div className="flex items-center gap-3">
            <button onClick={() => setIsDemoModalOpen(true)} className="px-4 py-2 bg-indigo-600 text-white text-sm font-semibold rounded-lg hover:bg-indigo-700">
              Request Demo
            </button>
            <Link to="/" className="text-slate-600 hover:text-slate-900 p-2 rounded-lg hover:bg-slate-100">
              <FiArrowLeft className="w-5 h-5" />
            </Link>
          </div>
        </div>
      </header>

      <main className="w-full max-w-4xl mx-auto px-4 sm:px-6 py-8 sm:py-12">
        <div className="mb-8">
          <div className="flex items-center gap-2 text-sm text-indigo-600 font-semibold mb-3">
            <span className="bg-indigo-50 px-3 py-1 rounded-full">Blog</span>
            <span className="text-slate-400">•</span>
            <span className="text-slate-500">{post.date}</span>
          </div>
          <h1 className="text-3xl sm:text-4xl font-extrabold text-slate-900 leading-tight">{post.title}</h1>
          <p className="mt-4 text-lg text-slate-600">{post.description}</p>
          <div className="mt-6 flex flex-wrap items-center gap-4 text-sm text-slate-500">
            <span className="flex items-center gap-2"><FiUser className="w-4 h-4" />By {post.author}</span>
            <span className="flex items-center gap-2"><FiClock className="w-4 h-4" />{post.readTime}</span>
            <span className="bg-indigo-50 text-indigo-600 px-2.5 py-0.5 rounded-full text-xs font-bold">{post.category}</span>
          </div>
        </div>

        <ContentComponent />

        <div className="mt-12 bg-indigo-600 rounded-2xl p-8 text-white">
          <div className="max-w-2xl">
            <h2 className="text-2xl font-bold mb-3">Ready to Transform Your Institution?</h2>
            <p className="text-indigo-100">Stop wasting time. Join thousands of Indian institutions that trust Truyon.</p>
            <button onClick={() => setIsDemoModalOpen(true)} className="mt-6 px-8 py-3 bg-white text-indigo-600 font-bold rounded-xl hover:bg-indigo-50 inline-flex items-center gap-2">
              Get Started Free <FiArrowRight className="w-4 h-4" />
            </button>
          </div>
        </div>
      </main>

      {isDemoModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm">
          <div className="bg-white rounded-3xl p-6 max-w-md w-full shadow-2xl">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-xl font-bold text-slate-900">Get Started Free</h3>
              <button onClick={() => setIsDemoModalOpen(false)} className="text-slate-400 hover:text-slate-600"><FiX className="w-5 h-5" /></button>
            </div>
            <p className="text-slate-600 text-sm mb-6">Stop losing time. Start your free Truyon journey today.</p>
            <div className="flex flex-col gap-3">
              <button onClick={() => { setIsDemoModalOpen(false); navigate('/signup'); }} className="w-full py-3 bg-indigo-600 text-white rounded-xl font-semibold hover:bg-indigo-700">
                Sign Up Free
              </button>
              <button onClick={() => { setIsDemoModalOpen(false); navigate('/request-demo'); }} className="w-full py-3 bg-slate-100 text-slate-700 rounded-xl font-semibold hover:bg-slate-200">
                Request a Demo
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BlogPost;